import React from "react";

import EnterMobileForLogin from "../component/sections/Auth/EnterMobileForLogin";
import LoginWithMobile from "../component/sections/Auth/LoginWithMobile";
import Logout from "../component/sections/Auth/Logout";
import middleware from "./middlewares/middleware";
import NotFounded from "../component/partials/other/NotFounded";
import ForgetPassword from "../component/sections/Auth/ForgetPassword";
import Login from "../component/sections/Auth/Login";
import Register from "../component/sections/Auth/Register";
import ResetPassword from "../component/sections/Auth/ResetPassword";
import ComeBackFromGoogle from "../component/sections/Auth/ComeBackFromGoogle";

const authRoutes = [
  // {
  //   path: "/enter-mobile-for-login",
  //   render: () => <EnterMobileForLogin />,
  //   exact: true,
  // },
  // {
  //   path: "/login-with-mobile",
  //   render: () => <LoginWithMobile />,
  //   exact: true,
  // },
  {
    path: "/logout",
    render: () => {
      return middleware(["isUserLogin"], <Logout />, "Logout");
    },
    exact: true,
  },
  {
    path: "/forget-password",
    render: () => {
      return middleware(["isUserLogout"], <ForgetPassword />, "ForgetPassword");
    },
    exact: true,
  },
  {
    path: "/reset-password",
    render: () => {
      return middleware(
        ["isUserLogout", "hasToken"],
        <ResetPassword />,
        "ResetPassword"
      );
    },
    exact: true,
  },
  {
    path: "/login",
    render: () => {
      return middleware(["isUserLogout"], <Login />, "Login");
    },
    exact: true,
  },
  {
    path: "/register",
    render: () => {
      return middleware(["isUserLogout"], <Register />, "Register");
    },
    exact: true,
  },
  {
    path: "/come-back-from-google",
    render: () => {
      return middleware(
        ["isUserLogout"],
        <ComeBackFromGoogle />,
        "ComeBackFromGoogle"
      );
    },
    exact: true,
  },
];

export default authRoutes;
